module.exports = __webpack_public_path__ + "img/beneficio-mobilidade.6222fb9d.svg";